/**
 * Ocean 域：巨量广告红线规则配置 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 *
 * 与后端 Pydantic 模型 src.ocean.dtos.ocean_redline_config 对齐。
 *   - GET  /api/v1/ocean/redline-config        → 全表读
 *   - PUT  /api/v1/ocean/redline-config        → 保存（upsert 一批行）
 *   - POST /api/v1/ocean/redline-config/seed   → 空表读 CSV 种入 5 行默认
 *
 * 巨量 targeting_id 取值：
 *   - legal_date / launch_time_series：与腾讯同构（、-joined 周几 / 时段串）。
 *   - bid_limit：JSON 数组 [{rta_id,external_action,bidlimit}, ...]。
 *   - qudaohao：JSON 数组 [{"渠道号":"留资ID"}, ...]。
 *   - regions：展业地域已迁移到「我的资源 - 展业城市」（数据源 auto_ad_legal_business_regions），
 *     该行为死配置，配置页读 / 存两侧均过滤。
 */

import { request } from "../apiClient";

/** 巨量红线规则配置行（与后端 OceanRedlineConfigItem 对齐）。 */
export interface OceanRedlineConfigItem {
  targeting_type: string;
  targeting_id: string;
  targeting_name: string;
  ext_info?: string | null;
}

/** 巨量红线规则配置行（含审计列，与后端 OceanRedlineConfigRecord 对齐）。 */
export interface OceanRedlineConfigRecord extends OceanRedlineConfigItem {
  create_user?: string | null;
  modify_user?: string | null;
  created_time?: string | null;
  updated_time?: string | null;
}

export interface SaveOceanRedlineConfigBody {
  rows: OceanRedlineConfigItem[];
}

/** 获取全部巨量红线规则配置（按 targeting_type 排序）。 */
export async function getOceanRedlineConfig(): Promise<OceanRedlineConfigRecord[]> {
  const data = await request<OceanRedlineConfigRecord[] | null>(
    "/api/v1/ocean/redline-config",
  );
  return data ?? [];
}

/** 保存（upsert）一批巨量红线配置行；返回保存后全表（含更新后的审计列）。 */
export async function saveOceanRedlineConfig(
  body: SaveOceanRedlineConfigBody,
): Promise<OceanRedlineConfigRecord[]> {
  const data = await request<OceanRedlineConfigRecord[] | null>(
    "/api/v1/ocean/redline-config",
    { method: "PUT", body },
  );
  return data ?? [];
}

/** 空表时读 CSV 种入 5 行默认红线配置；返回本次种入行数（非空表返回 0）。 */
export async function seedOceanRedlineConfig(): Promise<number> {
  const data = await request<{ seeded: number } | null>(
    "/api/v1/ocean/redline-config/seed",
    { method: "POST" },
  );
  return data?.seeded ?? 0;
}
